module.exports = __webpack_public_path__ + "media/images/flags/IM-d4d3158b80f86369641c3e1a510a48f8.svg";